import { FormField } from './form-field';

export class AutocompleteField extends FormField<string> {
  override controlType = 'autocomplete';
  constructor(options: any = {}) {
    super(options);
    this.options = options[`options`] || [];
  }
}
